import { useMutation } from "react-query";
import { getTimeRangeTransaction } from "../api/GatewayApi"
import { Skeleton } from "antd"
import { useEffect, useState } from "react";
import { Column } from '@ant-design/plots';
export default function Histogram(props) {
    const [data, setData] = useState([])
    const { mutate: transactionDashboard, isLoading: postLoading} = useMutation(
        () => getTimeRangeTransaction(props.fromdate,props.todate),
        {
            onSuccess: (data) => {
                if(data.code==200){
                    setData(data.payload)
                }
                // Success actions
            },
            onError: (error) => {
                // Error actions
                console.log("error",error)
            },
        }
    );

    if (postLoading) {
        <Skeleton active />
    }

    useEffect(() => {
        transactionDashboard()
    }, [])
    useEffect(() => {
        transactionDashboard()
    }, [props])
 
    const config = {
        data:data,
        isGroup: true,
        xField: 'date',
        yField: 'value',
        seriesField: 'type',
        label: {
          position: 'middle',
          layout: [
            {
              type: 'interval-adjust-position',
            },
            {
              type: 'interval-hide-overlap',
            }, 
            {
              type: 'adjust-color',
            },
          ],
        },
    };
    return <Column {...config} />;
}